// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l5sXecivVo46kNfkXLDz {
  margin: 0 auto;
}

.ehfUNo7aLZ0_hFgwYqN6 {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}

.ZWJLzuuoKi1Wod4wLOfo {
  align-items: center;
}
@media screen and (min-width: 800px) {
  .ZWJLzuuoKi1Wod4wLOfo {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./packages/dre-magi-translate/frontend/src/pages/notFound/NotFound.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;AAAE;EAFF;IAGI,aAAA;EAGF;AACF","sourceRoot":""}]);
// Exports
export var section = `l5sXecivVo46kNfkXLDz`;
export var column = `ehfUNo7aLZ0_hFgwYqN6`;
export var columns = `ZWJLzuuoKi1Wod4wLOfo`;
export default ___CSS_LOADER_EXPORT___;
